import { DRIP_ERROR_LABELS } from '../../constants';
export const extractDripErrorCodes = (error) => {
    if (error == null || typeof error !== 'object')
        return [];
    const response = error.response;
    if (response == null || typeof response !== 'object')
        return [];
    const data = response.data;
    if (data == null || typeof data !== 'object')
        return [];
    const body = data;
    const errors = Array.isArray(body.errors) ? body.errors : [body.errors];
    return Array.from(new Set([body.code, body.error, ...errors, body.detail].filter((code) => typeof code === 'string' && /^[a-z][a-z0-9_]*$/.test(code))));
};
export const extractDripErrorMessage = (error) => {
    const codes = extractDripErrorCodes(error);
    const messages = codes.map((code) => {
        const message = Object.prototype.hasOwnProperty.call(DRIP_ERROR_LABELS, code)
            ? DRIP_ERROR_LABELS[code]
            : 'The drip request failed. Please try again.';
        return `${message.replace(/[.\s]+$/, '')}.`;
    });
    return messages.length
        ? Array.from(new Set(messages)).join(' ')
        : 'The drip request failed. Please try again.';
};
export const extractDripErrorCode = (error) => extractDripErrorCodes(error)[0] ?? null;
